import loadable from "@loadable/component";
import KnowledgeBase from "../pages/KnowledgeBase";
import EditKnowledgeBase from "../pages/EditKnowledgeBase";
import QuoteForm from "../pages/QuoteForm";
// import Home from "../pages/Home";
// import Download from "../pages/Download";
// import ManageShop from "../pages/ManageShop";
// import Shop from "../pages/Shop";
// import Registration from "../pages/Registration";
// import CustomerData from "../pages/CustomerData";
// import ChangePassword from "../pages/ChangePassword";
// import Order from "../pages/Order";
// import Payment from "../pages/Payment";
// import Quote from "../pages/Quote";
// import AdminDashboard from "../pages/AdminDashboard";
// import ContactUs from "../pages/ContactUs";
const IndexPage = loadable(() => import("../pages/IndexPage"));
const Home = loadable(() => import("../pages/Home"));
const Download = loadable(() => import("../pages/Download"));
const ManageShop = loadable(() => import("../pages/ManageShop"));
const TermsOfService = loadable(() => import("../pages/TermsOfService"));
const HelpDocumentation = loadable(() => import("../pages/HelpDocumentation"));
const PricingSheetBuilder = loadable(() => import("../pages/PricingSheetBuilder"));
const ProposalBuilder = loadable(() => import("../pages/ProposalBuilder"));
const EnergyStorageSoftware = loadable(() =>
  import("../pages/EnergyStorageSoftware")
);
const Registration = loadable(() => import("../pages/Registration"));
const FreeAcademicLicense = loadable(() =>
  import("../pages/FreeAcademicLicense")
);
const CustomerData = loadable(() => import("../pages/CustomerData"));
const ChangePassword = loadable(() => import("../pages/ChangePassword"));
const Order = loadable(() => import("../pages/Order"));
const Payment = loadable(() => import("../pages/Payment"));
const Quote = loadable(() => import("../pages/Quote"));
const AdminDashboard = loadable(() => import("../pages/AdminDashboard"));
const ContactUs = loadable(() => import("../pages/ContactUs"));
const AboutUs = loadable(() => import("../pages/AboutUs"));
const PrivacyPolicy = loadable(() => import("../pages/PrivacyPolicy"));
const ES = loadable(() => import("../pages/ES"));
const KBArticle = loadable(() => import("../pages/KBArticle"));
const PDFContentViewer = loadable(() => import("../pages/PdfContent"));
const ArticleDetails = loadable(() => import("../pages/ArticleDetails"));
const HubSpotDashboard = loadable(() => import("../pages/HubSpotDashboard"));
const ChartsPage = loadable(() => import("../pages/ChartsPage"));
const LicenseSerach = loadable(() =>import("../pages/LicenseSearch"))
const SoftwareAnalytics = loadable(() =>import("../pages/SoftwareAnalytics"))
const LicenseManagement = loadable(() => import("../pages/LicenseManagement"))
// const DeveloperValueProp = loadable(() => import("../pages/DevelopersValueProposition"))
const BessModelBuilderRequestForm = loadable(() => import("../pages/BessModelBuilderRequestForm"))
const PendingBessModel = loadable(() => import("../pages/PendingBessModel"))
const SolutionsTabPage = loadable(() =>
  import("../pages/solutions/SolutionsTabPage")
);

const routes = [
  {
    path: "/terms-of-service",
    component: TermsOfService,
    exact: true,
    is_auth: false,
    name: "terms_of_service",
  },
  {
    path: "/HelpDocumentation",
    component: HelpDocumentation,
    exact: true,
    is_auth: false,
    name: "HelpDocumentation",
  },
  {
    path: "/",
    component: IndexPage,
    exact: true,
    is_auth: false,
    name: "index",
  },
  {
    path: "/energy_storage_software",
    component: EnergyStorageSoftware,
    exact: true,
    is_auth: false,
    name: "energy_storage_software",
  },
  {
    path: "/download",
    component: Download,
    exact: true,
    is_auth: false,
    name: "download",
  },
  {
    path: "/energy_storage_consulting",
    component: ES,
    exact: true,
    is_auth: false,
    name: "energy_storage_consulting",
  },
  {
    path: "/knowledge_base",
    component: KnowledgeBase,
    exact: true,
    is_auth: false,
    name: "knowledge_base",
  },
  {
    path: "/knowledge_base/:id",
    component: KBArticle,
    exact: true,
    is_auth: false,
    name: "knowledge_base/:id",
  },
  {
    path: "/knowledge-base/edit/:id",
    component: EditKnowledgeBase,
    exact: true,
    is_auth: false,
    name: "knowledge-base/edit/:id",
  },
  {
    path: "/contact_us",
    component: ContactUs,
    exact: true,
    is_auth: false,
    name: "contact_us",
  },
  {
    path: "/request-free-academic-license",
    component: FreeAcademicLicense,
    exact: true,
    is_auth: false,
    name: "request-free-academic-license",
  },
  {
    path: "/quote-for-consulting",
    component: QuoteForm,
    exact: true,
    is_auth: false,
    name: "quote-for-consulting",
  },
  {
    path: "/about_us",
    component: AboutUs,
    exact: true,
    is_auth: false,
    name: "about_us",
  },
  {
    path: "/register",
    component: Registration,
    exact: true,
    is_auth: false,
    name: "register",
  },
  {
    path: "/shop/login",
    component: ManageShop,
    exact: true,
    is_auth: false,
    name: "login",
  },
  {
    path: "/home",
    component: Home,
    exact: true,
    is_auth: true,
    name: "home",
  },
  {
    path: "/home/customer-data",
    component: CustomerData,
    is_auth: true,
    exact: true,
    name: "customer_data",
  },
  {
    path: "/home/modify_profile/:user_id",
    component: Registration,
    is_auth: true,
    exact: true,
    name: "modify_profile",
  },
  {
    path: "/home/order",
    component: Order,
    is_auth: true,
    exact: true,
    name: "order",
  },
  {
    path: "/home/payment",
    component: Payment,
    is_auth: true,
    exact: true,
    name: "payment",
  },
  {
    path: "/home/quote",
    component: Quote,
    is_auth: true,
    exact: true,
    name: "quote",
  },
  {
    path: "/home/change_password",
    component: ChangePassword,
    is_auth: true,
    exact: true,
    name: "change_password",
  },
  {
    path: "/home/request-free-bess-model-builder-license",
    component: BessModelBuilderRequestForm,
    exact: true,
    is_auth: true,
    name: "request-free-bess-model-builder-license",
  },
  {
    path: "/administrator/dashboard",
    component: AdminDashboard,
    is_auth: true,
    exact: true,
    name: "admin_dashboard",
  },
  {
    path: "/administrator/hubspot-dashboard",
    component: HubSpotDashboard,
    exact: true,
    is_auth: true,
    name: "hubspot_dashboard",
  },
  {
    path: "/administrator/hubspot-charts",
    component: ChartsPage,
    exact: true,
    is_auth: true,
    name: "charts_page",
  },
  {
    path: "/administrator/pricing-sheet-builder",
    component: PricingSheetBuilder,
    exact: true,
    is_auth: true,
    name: "pricing_sheet_builder",
  },
  {
    path: "/administrator/pending-bess-model-builder-requests",
    component: PendingBessModel,
    exact: true,
    is_auth: true,
    name: "pending_bess_model",
  },
  {
    path: "/administrator/proposal-builder",
    component: ProposalBuilder,
    exact: true,
    is_auth: true,
    name: "proposal_builder",
  },
  {
    path: "/PrivacyPolicy",
    component: PrivacyPolicy,
    exact: true,
    is_auth: false,
    name: "PrivacyPolicy",
  },
  {
    path: "/ArticleDetails/:id",
    component: ArticleDetails,
    is_auth: false,
    exact: true,
    name: "ArticleDetails",
  },
  {
    path: "/activation-guide",
    component: (props) => <PDFContentViewer {...props} pageName="download" />,
    is_auth: false,
    pageName: "download",
    name: "activation-guide",
  },
  {
    path: "/administrator/user-search",
    component:LicenseSerach,
    is_auth: true,
    exact:true,
    name: "LicenseSearch",
  },
  {
    path: "/administrator/software-analytics",
    component:SoftwareAnalytics,
    is_auth: true,
    exact:true,
    name: "SoftwareAnalytics",
  },
  {
    path: "/administrator/license-management",
    component: LicenseManagement,
    is_auth: true,
    exact:true,
    name: "LicenseManagement",
  },
  // {
  //   path: "/solutions/developers",
  //   component: DeveloperValueProp,
  //   is_auth: false,
  //   exact:true,
  //   name: "DeveloperValueProposition",
  // }
  {
    path: "/solutions/:tab",
    component: SolutionsTabPage,
    is_auth: false,
    exact: true,
    name: "SolutionsTabPage",
  }

];

export default routes;
